// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IBFR","comment":"styles_comment__2xpHx"};